import {
  DEFAULT_REDIRECT_PATH,
  DEFAULT_FEISHU_QR_SDK_URL,
  DEFAULT_FEISHU_REDIRECT_PATH,
} from './constants';

// 裸常量由 config/config.ts define 在构建时注入，
// Jest 环境通过 jest.config.ts globals 提供相同值，两端行为一致。
// 参考：https://pro.ant.design/docs/environment-manage
const feishuConfig = {
  redirectPath: UMI_APP_FEISHU_REDIRECT_PATH || DEFAULT_FEISHU_REDIRECT_PATH,
  qrSdkUrl: UMI_APP_FEISHU_QR_SDK_URL || DEFAULT_FEISHU_QR_SDK_URL,
};

export const FEISHU_LOGIN_STATE_STORAGE_KEY = 'ulp.feishu.login.state';
export const FEISHU_LOGIN_REDIRECT_STORAGE_KEY = 'ulp.feishu.login.redirect';

const getWindowOrigin = () =>
  typeof window === 'undefined' ? '' : window.location.origin;

const getSessionStorage = () =>
  typeof window === 'undefined' ? undefined : window.sessionStorage;

// 登录回跳只允许站内路径，避免把外部地址写入登录流程。
export const normalizeRedirectPath = (redirect?: string | null) => {
  if (!redirect) {
    return DEFAULT_REDIRECT_PATH;
  }

  const currentOrigin = getWindowOrigin();
  if (!currentOrigin) {
    return redirect.startsWith('/') ? redirect : DEFAULT_REDIRECT_PATH;
  }

  try {
    const redirectUrl = new URL(redirect, currentOrigin);
    if (redirectUrl.origin !== currentOrigin) {
      return DEFAULT_REDIRECT_PATH;
    }

    return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
  } catch {
    return DEFAULT_REDIRECT_PATH;
  }
};

export const getFeishuRedirectUri = () => {
  const currentOrigin = getWindowOrigin();
  if (!currentOrigin) {
    return feishuConfig.redirectPath;
  }

  return new URL(feishuConfig.redirectPath, currentOrigin).toString();
};

// 发起飞书登录前先缓存 state 和目标页，回调时再安全恢复。
export const rememberPendingFeishuLogin = (
  state: string,
  redirect?: string | null,
) => {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  const safeRedirect = normalizeRedirectPath(redirect);
  storage.setItem(FEISHU_LOGIN_STATE_STORAGE_KEY, state);
  storage.setItem(FEISHU_LOGIN_REDIRECT_STORAGE_KEY, safeRedirect);
};

export const getFeishuQrSdkUrl = () => feishuConfig.qrSdkUrl;

// 回调时必须命中之前写入的 state，才允许继续登录流程。
export const validateFeishuLoginState = (state?: string | null) => {
  const storage = getSessionStorage();
  return Boolean(state && storage?.getItem(FEISHU_LOGIN_STATE_STORAGE_KEY) === state);
};

export const clearPendingFeishuLogin = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(FEISHU_LOGIN_STATE_STORAGE_KEY);
  storage.removeItem(FEISHU_LOGIN_REDIRECT_STORAGE_KEY);
};

export const consumeFeishuLoginRedirect = () => {
  const storage = getSessionStorage();
  const redirect = normalizeRedirectPath(
    storage?.getItem(FEISHU_LOGIN_REDIRECT_STORAGE_KEY),
  );

  clearPendingFeishuLogin();

  return redirect;
};
